export const FEEDBACK_GROUP_ID = 'jira-servicedesk-ai-context-panel-service';
export const AI_CONTEXT_PANEL_DWELL_DELAY = 2000;
